<template>
  <div class="works">
    <!-- <div class="search_bar">
      <el-form
        :model="searchForm"
        ref="searchForm"
        class="search_form"
        :inline="true"
        size="small"
      >
        <el-form-item label="" prop="query">
          <el-input
            v-model="searchForm.query"
            placeholder="请输入关键词"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="userId">
          <el-select
            v-model="searchForm.userId"
            filterable
            placeholder="请选择或输入学生姓名"
          >
            <el-option
              v-for="item in studentList"
              :key="item.userId"
              :label="item.name + ' ' + item.sno"
              :value="item.userId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="classChapterId" v-show="!isDetailPage">
          <el-cascader
            v-model="searchForm.classChapterId"
            :options="chapters"
            @change="getTaskList"
            :props="{
              label: 'title',
              value: 'classChapterId',
              emitPath: false,
            }"
            :show-all-levels="false"
            placeholder="请选择章节"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="" prop="taskId">
          <el-select
            v-model="searchForm.taskId"
            placeholder="请选择实战"
            clearable
            :no-data-text="
              searchForm.classChapterId ? '无数据' : '请先选择章节'
            "
          >
            <el-option
              v-for="item in taskList"
              :key="item.taskId"
              :label="item.title"
              :value="item.taskId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="marked">
          <el-radio-group
            v-model="searchForm.marked"
            size="small"
            @change="getList"
          >
            <el-radio-button :label="null">全部</el-radio-button>
            <el-radio-button :label="true">已评分</el-radio-button>
            <el-radio-button :label="false">未评分</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="btns" style="float: right; margin-right: 0">
          <el-button type="primary" @click="getList">查询</el-button>
          <el-button @click="resetForm('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div> -->
    <div class="work_box" :class="{ 'detail-page': isDetailPage }">
      <template v-if="total > 0">
        <div class="one_work" v-for="item in workList" :key="item.id">
          <el-image
            class="avatar"
            :src="item.worksType == 'TEAM' ? item.teamIcon : item.avatar"
            fit="cover"
          ></el-image>
          <div class="right_content">
            <div class="work">
              <p class="name">
                {{ item.worksType == "TEAM" ? item.teamName : item.nickName }}
                <!-- <el-tag size="mini" effect="dark" style="margin-left: 20px">{{
                  item.worksType == "TEAM" ? "团队作品" : "个人作品"
                }}</el-tag>
                <el-tag
                  v-show="item.great"
                  size="mini"
                  effect="dark"
                  type="danger"
                  style="margin-left: 10px"
                  >优秀</el-tag
                >
                <el-tag
                  v-show="item.typical"
                  size="mini"
                  effect="dark"
                  type="warning"
                  style="margin-left: 10px"
                  >典型</el-tag
                > -->
                <i
                  class="el-icon-error"
                  @click="handleDelWorks(item.worksId)"
                  title="删除"
                ></i>
                <i
                  class="el-icon-s-release"
                  @click="handleRepulse(item.worksId)"
                  title="打回"
                ></i>
              </p>
              <div class="bottom_row clearfix">
                <!-- <span class="chapter_name"
                  >{{ item.chapterName }} —
                  {{ item.taskId == 0 ? "默认实战" : item.taskTitle }}</span
                >
                <span class="time">{{
                  formatDate(item.createTime, "YYYY-MM-DD HH:mm:ss")
                }}</span> -->
                <div class="right_btns">
                  <span
                    class="score-text avg"
                    v-if="item.studentScoreList.length > 0"
                    @click="showAvgList(item.studentScoreList)"
                    >学生评分均分：{{ getAvg(item.studentScoreList) }}</span
                  >
                  <span class="score-text" v-if="item.score"
                    >教师的评分：{{ item.score }}</span
                  >

                  <i
                    class="el-icon-coin icon"
                    @click="
                      handleScore(
                        item.worksId,
                        item.score,
                        item.great,
                        item.typical
                      )
                    "
                  ></i>
                  <i
                    class="el-icon-chat-dot-square icon"
                    @click="
                      myComment = '';
                      currentWorksId = item.worksId;
                    "
                  ></i>

                  <!-- <img
                    :src="
                      item.fabulous
                        ? require('@/assets/images/icons/icon_like_full.png')
                        : require('@/assets/images/icons/icon_like.png')
                    "
                    alt=""
                    @click="handleLike(item)"
                  /> -->
                </div>
              </div>
              <p class="text_content" v-if="item.info">
                {{ item.info }}
              </p>
              <div class="media_content">
                <div
                  class="one_media"
                  v-for="t in item.showFiles"
                  :key="t.worksFileId"
                >
                  <video
                    v-if="t.type == 'mp4'"
                    :src="t.url"
                    controls="controls"
                  ></video>

                  <el-image
                    style="width: 100%; height: 100%"
                    v-else
                    :src="t.url"
                    :preview-src-list="getImgList(t)"
                  >
                  </el-image>
                </div>
                <div
                  class="other-type"
                  v-for="t in item.otherFiles"
                  :key="t.worksFileId"
                >
                  <i class="el-icon-document"></i>
                  <a :href="t.url" target="_blank" title="点击下载" download>{{
                    t.fileName
                  }}</a>
                </div>
              </div>
            </div>
            <div
              class="comments"
              v-if="item.commentList && item.commentList.length > 0"
            >
              <div
                class="one_comment"
                v-for="comment in item.commentList"
                :key="comment.id"
              >
                <p class="c_row">
                  <span class="c_name">{{ comment.nickName }}：</span>
                  <span class="c_content">{{ comment.info }}</span>
                </p>
                <i
                  class="el-icon-error"
                  @click="handleDelComment(comment.commentId)"
                ></i>
              </div>
            </div>

            <div class="reply_edit" v-if="currentWorksId == item.worksId">
              <el-input
                v-model="myComment"
                type="textarea"
                resize="none"
                :autosize="{ minRows: 3 }"
                :placeholder="'回复 ' + item.nickName + ':'"
              ></el-input>
              <div class="btn_row">
                <el-button
                  size="small"
                  round
                  @click="currentWorksId = null"
                  style="width: 80px"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  round
                  @click="handlePublish"
                  style="width: 80px"
                  >评价</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </template>
      <el-empty description="暂无作品" v-else></el-empty>
    </div>

    <div class="foot_page">
      <el-pagination
        background
        layout="prev, pager, next, jumper"
        :page-size="searchForm.limit"
        :current-page.sync="searchForm.page"
        :total="total"
        @current-change="getList"
      >
      </el-pagination>
    </div>

    <el-dialog title="学生评分列表" :visible.sync="showAvg" center width="50%">
      <el-table class="avg-list" :data="avgList">
        <el-table-column
          prop="nickName"
          label="姓名"
          width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="sno" label="学号" width="120" align="center">
        </el-table-column>
        <el-table-column prop="score" label="评分" width="100" align="center">
        </el-table-column>
        <el-table-column prop="teamName" label="所属团队" align="center">
          <template slot-scope="scope">
            {{ scope.row.teamName || "无" }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :visible.sync="showScore" center width="30%">
      <el-form label-width="100px">
        <!-- <el-form-item label="置顶">
          <el-checkbox v-model="great">优秀</el-checkbox>
          <el-checkbox v-model="typical">典型</el-checkbox>
        </el-form-item> -->
        <el-form-item label="得分">
          <el-input-number
            v-model="score"
            :min="0"
            :max="100"
            size="small"
            :controls="false"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="showScore = false">关闭</el-button>
        <el-button type="primary" size="small" @click="handleGiveEvaluate"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  worksList,
  delWorks,
  refuseWorks,
  giveComment,
  delComment,
  giveGrade,
} from "@/api/works";
import { practiceList } from "@/api/practice";
import { chapterList } from "@/api/chapter";
import { handleTree } from "@/utils";
import { formatDate } from "@/utils/index";
export default {
  data() {
    return {
      formatDate,
      searchForm: {
        page: 1,
        limit: 10,
        classId: this.$route.query.id,
        userId: null,
        query: "",
        classChapterId: null,
        taskId: null,
        marked: null,
      },
      total: 10,
      chapters: [],
      taskList: [],
      activeId: null,
      workList: [],
      srcList: [],
      myComment: "",
      currentWorksId: null,
      isDetailPage: false,
      showAvg: false,
      avgList: [],
      score: 0,
      typical: false,
      great: false,
      currentId: null,
      showScore: false,
    };
  },
  created() {
    this.getChapterList();
    this.getList();
    if (this.$route.path == "/courseDetail/works") {
      this.isDetailPage = true;
      this.getTaskList();
    }
  },

  computed: {
    studentList() {
      return this.$store.state.studentList;
    },
    update() {
      return this.$store.state.update;
    },
  },
  watch: {
    update(val) {
      if (val) {
        this.getList();
        this.$store.commit("SET_UPDATE", false);
      }
    },
  },
  methods: {
    // 作品列表
    getList() {
      if (this.$route.query.classChapterId)
        this.searchForm.classChapterId = this.$route.query.classChapterId;
      this.$loading.show();
      worksList(this.searchForm).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          // console.log(res);
          res.data.records.forEach((item) => {
            item.showFiles = [];
            item.otherFiles = [];
            item.fileList.forEach((file) => {
              file.type = file.type ? file.type.toLowerCase() : "";
              if (
                file.type != "mp4" &&
                file.type != "png" &&
                file.type != "jpg" &&
                file.type != "jpeg" &&
                file.type != "gif"
              ) {
                item.otherFiles.push(file);
              } else {
                item.showFiles.push(file);
              }
            });
          });
          this.workList = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 章节列表
    getChapterList() {
      chapterList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.chapters = handleTree(res.data, "chapterId");
          // let arr = [];
          // let chapters = handleTree(res.data, "chapterId");
          // chapters.forEach((item) => {
          //   if (item.children) {
          //     arr.push(item);
          //     arr = arr.concat(item.children);
          //   }
          // });
          // this.chapters = arr;
          // this.chapters = res.data.filter((item) => {
          //   return item.sz;
          // });
        } else {
          console.log(res.msg);
        }
      });
    },
    // 实战列表
    getTaskList() {
      practiceList({
        classId: this.$route.query.id,
        classChapterId: this.isDetailPage
          ? this.$route.query.classChapterId
          : this.searchForm.classChapterId,
      }).then((res) => {
        if (res.code == 0) {
          this.taskList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getTaskList();
      this.getList();
    },
    getImgList(t) {
      let images = [];
      images.push(t.url);
      return images;
    },
    // 点赞
    // handleLike(item) {
    //   item.fabulous = !item.fabulous;
    // },
    // 发表评论
    handlePublish() {
      this.$loading.show();
      giveComment({ worksId: this.currentWorksId, info: this.myComment }).then(
        (res) => {
          this.$loading.hide();
          if (res.code == 0) {
            this.$message.success("发表成功");
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        }
      );
      this.currentWorksId = null;
      this.myComment = "";
    },
    // 删除评论
    handleDelComment(commentId) {
      this.$confirm("确定要删除这条评论吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delComment(commentId).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 打回作品
    handleRepulse(worksId) {
      this.$confirm("确定要打回该作品吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          refuseWorks(worksId).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("作品已打回");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 删除作品
    handleDelWorks(worksId) {
      this.$confirm("确定要删除该作品吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delWorks(worksId).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    getAvg(arr) {
      let sum = arr.reduce(function (prev, curr) {
        return curr.score + prev;
      }, 0);
      return Number((sum / arr.length).toFixed(2));
    },
    showAvgList(arr) {
      this.showAvg = true;
      this.avgList = arr;
    },
    handleScore(worksId, score, great, typical) {
      this.showScore = true;
      this.currentId = worksId;
      this.score = score;
      this.great = great;
      this.typical = typical;
    },
    // 评分
    handleGiveEvaluate() {
      this.$confirm(`确定要评分吗？`, {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          giveGrade({
            worksId: this.currentId,
            score: this.score,
            great: this.great,
            typical: this.typical,
          }).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.getList();
              this.showScore = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.works {
  margin-bottom: 50px;
  height: 100%;
  text-align: left;

  .upload_btn {
    margin-bottom: 20px;
    height: 36px;
    line-height: 36px;
    color: #1890ff;
    font-size: 20px;
    text-align: center;
    border: dashed 1px #1890ff;
    cursor: pointer;
    .el-icon-plus {
      margin-right: 5px;
    }
  }
  .search_form {
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 4px;
    background-color: #fff;

    .el-form-item {
      margin-bottom: 0;
      margin-right: 15px;
      &.no-margin {
        margin-right: 0;
      }
    }

    ::v-deep .el-input__inner {
      width: 190px;
    }
  }

  .work_box {
    padding: 30px;
    border-radius: 4px;
    background-color: rgb(185, 237, 255);
    &.detail-page {
      height: calc(100% - 76px - 70px);
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 4px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #c8c8c8;
      }
    }
    .one_work {
      margin-bottom: 18px;

      .avatar {
        margin-right: 20px;
        width: 64px;
        height: 64px;
        border-radius: 50%;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
        vertical-align: top;
      }
    }

    .el-empty {
      padding: 80px 0;
    }
  }

  .right_content {
    display: inline-block;
    width: calc(100% - 64px - 20px);
    border-bottom: solid 1px #c8c8c8;
    .work {
      .name {
        font-size: 16px;
        color: #333;
        font-weight: bold;

        .el-icon-error,
        .el-icon-s-release {
          float: right;
          margin-left: 10px;
          color: #f56c6c;
          font-size: 22px;
          cursor: pointer;
        }

        .el-icon-top {
          color: #1890ff;
          font-size: 24px;
          cursor: pointer;
        }
      }

      .text_content {
        margin-top: 15px;
        font-size: 16px;
      }

      .media_content {
        margin-top: 15px;
        margin-bottom: 15px;
        .one_media {
          display: inline-block;
          margin-right: 7px;
          width: 200px;
          height: 200px;
          border-radius: 5px;
          overflow: hidden;

          img,
          video {
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.4);
          }
        }
        .other-type {
          margin-top: 10px;
          font-size: 16px;
          a {
            margin-left: 5px;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }

      .bottom_row {
        margin: 10px 0;

        .chapter_name,
        .time {
          color: #0091ff;
          font-size: 14px;

          &.chapter_name {
            margin-right: 20px;
          }
        }

        .right_btns {
          // float: right;
          .score-text {
            margin-right: 10px;
            font-size: 14px;
            color: #0091ff;
            &.avg {
              cursor: pointer;
            }
          }
          .score_box {
            position: relative;
            display: inline-block;
            .score_text {
              position: absolute;
              top: -25px;
              left: 50%;
              transform: translateX(-50%);
              font-size: 16px;
              color: #409eff;
            }
            ::v-deep .score_slide {
              width: 200px;

              .el-slider__runway {
                margin: 0;
              }
            }
          }

          img {
            margin-left: 20px;
            width: 20px;
            cursor: pointer;
          }
          .icon {
            float: right;
            margin-left: 10px;
            font-size: 22px;
            color: #009dff;
            cursor: pointer;
            vertical-align: middle;
          }
        }
      }
    }

    .comments {
      margin-bottom: 15px;
      padding: 15px;
      background-color: #f2f6fc;
      // border-radius: 10px;

      .one_comment {
        position: relative;
        margin-bottom: 5px;
        .c_row {
          width: 98%;
          .c_name {
            font-size: 16px;
            color: #1890ff;
          }

          .c_content {
            font-size: 16px;
          }
        }

        .el-icon-error {
          position: absolute;
          right: 0;
          bottom: 0;
          color: #f56c6c;
          font-size: 20px;
          cursor: pointer;
        }
      }
    }

    .reply_edit {
      padding-bottom: 10px;

      .btn_row {
        margin-top: 10px;
        text-align: right;
      }
      ::v-deep .el-textarea__inner {
        font-family: inherit;
      }
    }
  }

  ::v-deep .foot_page {
    margin-top: 20px;
    text-align: right;

    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #0d79ff;
    }

    .el-pagination__total {
      float: left;
    }
  }

  ::v-deep .comment_dialog {
    .el-textarea__inner {
      font-family: inherit;
    }
  }

  ::v-deep .avg-list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>